@if (media && media.src) {
  <img
    [attr.src]="media.src"
    [attr.srcset]="!isUsingDefaultImage ? media.srcset : null"
    [attr.alt]="media.alt"
    [attr.role]="media.role"
    [attr.loading]="loading"
    [attr.fetchpriority]="fetchpriority"
    [attr.width]="width"
    [attr.height]="height"
    (load)="loadHandler()"
    (error)="errorHandler()"
  />
}
